module.exports = __webpack_public_path__ + "img/Grader.47f22f84.png";